export const convertFirstLetterToUppercase = (string) => {
	if (string) {
		let value = string?.charAt(0)?.toUpperCase() + string.slice(1)
		value = value.replace('-de-', ' de ')
		value = value.replace('-', ' ')
		return value
  }
  return false
};
